export enum PraClaimType {
  CME = 'CME',
  ABMS = 'ABMS',
  Residency = 'Residency',
  Reciprocity = 'Reciprocity',
}
